export const sortAll = () => {
  const sortButton = document.querySelector(".project__show-label");
  const sortList = document.querySelector(".project__show-list");

  function openList(event) {
    sortList.classList.add("project__show-list--opened");
  }

  if (sortButton) {
    sortButton.addEventListener("click", openList);
  }
};
